import { render, staticRenderFns } from "./professorCheck.vue?vue&type=template&id=19f3ed94"
import script from "./professorCheck.vue?vue&type=script&lang=js"
export * from "./professorCheck.vue?vue&type=script&lang=js"
import style0 from "./professorCheck.vue?vue&type=style&index=0&id=19f3ed94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports